import { sva } from '@agapi/ui/panda/css';

export const trackOrderStyles = sva({
  slots: [
    'section',
    'content',
    'iconContainer',
    'title',
    'subTitle',
    'formContainer',
    'loadingContainer',
    'errorContainer',
    'errorMessage',
    'widgetContainer',
    'widgetHeader',
    'backButton',
    'trackingIframe'
  ],
  base: {
    section: {
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      maxWidth: '700px',
      mx: 'auto',
      px: '4',
    },
    iconContainer: {
      backgroundColor: 'primary.200',
      borderRadius: 'full',
      width: '80px',
      height: '80px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      mb: '4',
      color: 'primary.900',
    },
    title: {
      fontSize: '3xl',
      fontWeight: 'semibold',
      mb: '6',
    },
    subTitle: {
      fontSize: 'lg',
      fontWeight: 'medium',
    },
    formContainer: {
      width: '100%',
      maxWidth: '450px',
      my: '6',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '4',
    },
    loadingContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '4',
      my: '8',
    },
    errorContainer: {
      backgroundColor: 'error.100',
      borderRadius: 'md',
      p: '5',
      my: '6',
      width: '100%',
    },
    errorMessage: {
      color: 'error.600',
      mb: '4',
    },
    widgetContainer: {
      width: '100%',
      mt: '4',
    },
    widgetHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      mb: '4',
    },
    backButton: {
      alignSelf: 'flex-end',
    },
    trackingIframe: {
      width: '100%',
      border: 'none',
      borderRadius: 'md',
      backgroundColor: 'bg.subtle',
      minHeight: '400px',
    },
  },
  variants: {},
  defaultVariants: {},
});